import React from 'react';

import './Loading.scss';

import commonConstant from '../../../common/_commonConstant';

export default () => (
  <div className="Loading">
    <div className="loading-box">
      <div className="bg">
        <img className="loading-img" src={commonConstant.loadingImg} alt="" />
      </div>
    </div>
  </div>
);
